export default __webpack_public_path__ + "static/media/Nunito-BlackItalic.ef47253f.woff2";